(function(){
'use strict';
var SEC='el-cart',st={ids:[]},d=document;
function $(s,r){return (r||d).querySelector(s)}
function roots(){return d.querySelectorAll('.elc-root')}
function parse(h){return new DOMParser().parseFromString(h,'text/html')}
function read(){var r=$('.elc-root [data-elc-ids]');st.ids=r?r.getAttribute('data-elc-ids').split(',').filter(Boolean).map(Number):[];d.dispatchEvent(new CustomEvent('elc:update',{detail:{ids:st.ids}}));}
function apply(s){
  if(s&&s[SEC]){var n=parse(s[SEC]).querySelector('.elc-root');if(n)roots().forEach(function(r){r.innerHTML=n.innerHTML});}
  if(s&&s['cart-icon-bubble']){var b=d.getElementById('cart-icon-bubble'),x=parse(s['cart-icon-bubble']).querySelector('.shopify-section');if(b&&x)b.innerHTML=x.innerHTML;}
  read();
}
function busy(on){roots().forEach(function(r){r.classList.toggle('is-busy',on)})}
function post(url,body){
  busy(true);body.sections=SEC+',cart-icon-bubble';body.sections_url=location.pathname;
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
  .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
  .then(function(j){busy(false);apply(j.sections);return j})
  .catch(function(e){busy(false);if(e&&e.description)alertBox(e.description);throw e});
}
function alertBox(m){var r=$('.elc-root .elc-in');if(!r)return;var p=d.createElement('p');p.className='elc-err';p.textContent=m;r.prepend(p);setTimeout(function(){p.remove()},5000)}
var el=null,last=null;
function open(){
  el=el||$('el-cart.elc');if(!el){if(location.pathname!=='/cart')location.href='/cart';return}
  last=d.activeElement;el.classList.add('is-open');el.setAttribute('aria-hidden','false');d.documentElement.classList.add('elc-lock');
  setTimeout(function(){var p=$('.elc-panel',el);p&&p.focus()},60);
}
function close(){if(!el)return;el.classList.remove('is-open');el.setAttribute('aria-hidden','true');d.documentElement.classList.remove('elc-lock');if(last&&last.focus)last.focus()}
function add(id){
  id=Number(id);
  if(st.ids.indexOf(id)>-1){open();return Promise.resolve()}
  return post('/cart/add.js',{items:[{id:id,quantity:1}]}).then(function(){open()});
}
window.ELCart={add:add,open:open,close:close,has:function(id){return st.ids.indexOf(Number(id))>-1}};
d.addEventListener('click',function(e){
  var t=e.target.closest('[data-elc-close],[data-elc-add],[data-elc-remove],[data-elc-swap],#cart-icon-bubble');
  if(!t)return;
  if(t.id==='cart-icon-bubble'){if($('el-cart.elc')){e.preventDefault();open()}return}
  e.preventDefault();
  if(t.hasAttribute('data-elc-close'))return close();
  if(t.hasAttribute('data-elc-add')){t.disabled=true;add(t.getAttribute('data-elc-add')).catch(function(){}).then(function(){t.disabled=false});return}
  if(t.hasAttribute('data-elc-remove'))return post('/cart/change.js',{id:t.getAttribute('data-elc-remove'),quantity:0}).catch(function(){});
  if(t.hasAttribute('data-elc-swap')){var u;try{u=JSON.parse('{'+t.getAttribute('data-elc-swap').replace(/,\s*$/,'')+'}')}catch(x){return}post('/cart/update.js',{updates:u}).catch(function(){})}
});
d.addEventListener('keyup',function(e){if(e.key==='Escape')close()});
d.addEventListener('change',function(e){
  if(!e.target.matches('[data-elc-consent]'))return;
  var f=e.target.form,h=f&&f.querySelector('[data-elc-date]');if(h)h.value=e.target.checked?new Date().toISOString():'';
  var c=e.target.closest('[data-elc-c]');c&&c.classList.remove('err');
});
d.addEventListener('invalid',function(e){
  if(!e.target.matches||!e.target.matches('[data-elc-consent]'))return;
  var c=e.target.closest('[data-elc-c]');if(!c)return;c.classList.remove('err');void c.offsetWidth;c.classList.add('err');
},true);
window.addEventListener('pageshow',function(e){if(e.persisted)fetch('/?sections='+SEC+',cart-icon-bubble').then(function(r){return r.json()}).then(apply).catch(function(){})});
if(d.readyState!=='loading')read();else d.addEventListener('DOMContentLoaded',read);
})();
